import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

export default function DynamicDialog({
  open,
  onClose,
  onSubmit,
  title = "Confirmation",
  message = "Are you sure you want to proceed?",
  cancelText = "Cancel",
  submitText = "Submit",
}) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {cancelText}
        </Button>
        <Button onClick={onSubmit} color="primary" variant="contained">
          {submitText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
